module.exports = __webpack_public_path__ + "static/media/email_icon.4564e6e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/icons/email_icon.svg
// module id = 1934
// module chunks = 1